import tippy from 'tippy.js'

export default function (state = {
	trigger: 'mouseenter focus',
}) {
	return {
		init() {
			tippy(this.$refs.trigger, {
				content: this.$refs.content.innerHTML,
				allowHTML: true,
				interactive: true,
				trigger: state.trigger,
			})
		},
	}
}
